import { Location } from '@angular/common';
import { Component, Input, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-back-button',
  templateUrl: './back-button.component.html',
  styleUrls: ['./back-button.component.scss'],
  standalone: false,
})
export class BackButtonComponent {
  readonly #route = inject(ActivatedRoute);
  readonly #location = inject(Location);

  back() {
    const backtop = this.#route.snapshot.queryParamMap.get('backtop');
    if (backtop) {
      window.location.href = environment.home_url;
    } else {
      this.#location.back();
    }
  }
}
